/**
* Получить значение строки локализации по ее коду.
*
* @global
* @function L
* @param {string} code Код строки
* @return {string} Значение строки локализации.
*
* @example
* // Получить значение строки локализации с кодом DESELECT_ALL.
* L('DESELECT_ALL')​​​​​​​
* // В результате появится строка «Снять выделение».
*/
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

/**
* Минимальная поддерживаемая веб-доступом ширина экрана.
* @global
*/
var MIN_SUPPORTS_WINDOW_WIDTH = 1024;
/**
* Минимальная поддерживаемая веб-доступом высота экрана.
* @global
*/
var MIN_SUPPORTS_WINDOW_HEIGHT = 768;
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

/**
* Возвратить строку, собранную из строки формата и переданных аргументов.
* Заменяет каждый элемент формата в строке, например {0}, {1} … {key}, текстовым эквивалентным значением.
* Не имеет возможности экранировать символы {}.
*
* @global
* @function format
* @param {String} text Строка, которую необходимо преобразовать
* @param {Params} Текстовые эквивалентные значения для замены
* @return {string} Строка, собранная из строки формата и переданных аргументов.
*
* @example
* a = "цветок"
* b = "Подсолнух";
* var result = format('{1} это {0}', a,b);
* //В результате появится строка «Подсолнух – это цветок»
*/
function format(str, params) {
  if (!str || arguments.length < 2) return str;
  var _params = params;
  if (arguments.length > 2 || typeof _params != "object")
    _params = Array.prototype.slice.call(arguments, 1);
  return str.replace(/\{([^{}]+)\}/g, function (s, key) {
    if (key in _params)
      return _params[key];
    else
      return s;
  });
}
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

/**
* Преобразовать дату в строку с учетом текущей локализации.
*
* @global
* @function formatDate
* @param {Date} date Дата.
* @param {String} format Формат даты.
* @return {string} Отформатированная строка даты.
*/
function formatDate(date, format) {
  if (!$.datepicker) return '';
  var df = format || $.datepicker.regional[currentCultureName].dateFormat;
  return $.datepicker.formatDate(df, date);
}
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

/**
* Преобразовать дату и время в строку с учетом текущей локализации.
*
* @global
* @function formatDateTime
* @param {Date} time Дата и время.
* @param {String} format Формат даты и времени.
* @return {string} Отформатированная строка.
*/
function formatDateTime(time, format) {
  if (!$.datepicker || !$.timepicker) return '';
  if (time === null) return '';
  var df, tf;

  if (format) {
    var formatParts = format.split(' ');
    df = formatParts[0];
    if (formatParts.length > 1) {
      tf = formatParts[1];
    } else {
      tf = '';
    }
  } else {
    df = $.datepicker.regional[currentCultureName].dateFormat;
    tf = $.timepicker.regional[currentCultureName].timeFormat;
  }

  var ampm = tf.indexOf('TT') > -1;
  var tmptime;
  var hours = time.getHours();
  var minutes = time.getMinutes();
  var seconds = time.getSeconds();

  // Если время 00:00:00, то отбрасываем его
  if (hours > 0 || minutes > 0 || seconds > 0) {
    if (ampm) {
      var hour12 = hours % 12;
      if (hour12 === 0)
        hour12 = 12;
      tmptime = tf
          .replace(/hh/g, leadzero(hour12))
          .replace(/h/g, hour12)
          .replace(/mm/g, leadzero(minutes))
          .replace(/m/g, minutes)
          .replace(/ss/g, leadzero(seconds))
          .replace(/s/g, seconds)
          .replace(/TT/g, (hours >= 12 ? 'PM' : 'AM'));
    } else {
      tmptime = tf
          .replace(/hh/g, leadzero(hours))
          .replace(/h/g, hours)
          .replace(/mm/g, leadzero(minutes))
          .replace(/m/g, minutes)
          .replace(/ss/g, leadzero(seconds))
          .replace(/s/g, seconds);
    }
    return formatDate(time, df) + ' ' + tmptime;
  } else {
    return formatDate(time, df)
  }
}
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

/**
* Преобразовать строку в дату и время с учетом текущей локализации.
*
* @global
* @function parseDateTime
* @param {string} date Строка даты в формате ДД.ММ.ГГГГ ЧЧ:ММ
* @return {Date} Отформатированная строка.
*
* @example
* parseDateTime('1')
* parseDateTime('12.11.2012')
* parseDateTime('12.11.12 14:21')
*/
var parseDateTime = ParseDateTime = function (inp) {

  var val;
  var d;
  var m;
  var y;
  var tmpDate;
  var daysInMonth;
  var i;
  var separator;
  var format;
  var russianLocale = 'ru-RU';
  var enLocale = 'en-US';
  var cultureName;

  if ($.type(inp) === "string") {
    val = $.trim(inp);
  } else {
    val = $.trim(inp.val());
  }
  if (!val) return null;

  if (val.indexOf('/Date(') === 0) {
    return new Date(parseInt(val.replace("/Date(", "").replace(")/", ""), 10));
  }

  cultureName = currentCultureName;

  if ($.type(inp) === "string") {
    if (inp.indexOf('.') !== -1) {
      cultureName = russianLocale;
    }

    if (inp.indexOf('/') !== -1) {
      cultureName = enLocale;
    }
  }

  var culture = $.datepicker.regional[cultureName];
  var separator = culture.dateseparator;
  var format = culture.dateFormat.split(separator);
  var timeFormat = $.timepicker.regional[cultureName].timeFormat.split(":");

  var today = new Date();
  var dmy = val.split(separator);

  var timeFormat;
  var time = [];

  for (i = 0; i < format.length; i++) {
    format[i] = $.trim(format[i]).substring(0, 1);
  }

  // Если ввели только одно число, то считаем, что нужен текущие месяц и год (время 00:00:00).
  if ((dmy.length === 1 && !!dmy[0] && parseInt(dmy[0], 10) > 0 && parseInt(dmy[0], 10) <= 31) || (dmy.length === 2 && !dmy[1])) {
    d = val;
    m = today.getMonth();
    y = today.getFullYear();
    tmpDate = new Date(y, m + 1, 0);
    daysInMonth = parseInt(tmpDate.getDate(), 10);

    if (daysInMonth >= d && d > 0) {
      return (new Date(y, m, d));
    } else {
      return null;
    }
  }

  // Если ввели два числа, то считаем, что нужен текущий год (время 00:00:00).
  if ((dmy.length === 2 && !!dmy[1]) || (dmy.length === 3 && !!dmy[1] && !dmy[2])) {
    d = dmy[format.indexOf("d")];
    m = parseInt(dmy[format.indexOf("m")], 10) - 1;
    y = today.getFullYear();
    tmpDate = new Date(y, m + 1, 0);
    daysInMonth = parseInt(tmpDate.getDate(), 10);

    if (daysInMonth >= d && d > 0 && m <= 11 && m >= 0)
      return (new Date(y, m, d));
    else
      return null;
  }

  // Если ввели 3 числа и среди них нет пустой строки
  if (dmy.length == 3 && dmy.indexOf("") == -1) {
    d = dmy[format.indexOf("d")];
    m = parseInt(dmy[format.indexOf("m")], 10) - 1;
    y = parseInt(dmy[format.indexOf("y")], 10);

    // Если год 2-хзначиное число и больше 60, это это прошлый век, иначе текущий.
    if (y < 100) {
      if (y > 60) y += 1900; else y += 2000;
    }

    // Для предотвращения ошибки "Переполнение SqlDateTime. Должно находиться в пределах от 1/1/1753 12:00:00 AM и 12/31/9999 11:59:59 PM.".
    if (y < 1800) {
      y = 1800;
    }

    tmpDate = new Date(y, m + 1, 0);
    daysInMonth = parseInt(tmpDate.getDate(), 10);

    time = null;

    // Если задано время либо время+AMPM (для английского формата)
    tmpTime = $.trim(val).split(" ");
    if (tmpTime.length > 1 && tmpTime.indexOf("") == -1) {
      // Удалим дату из массива
      tmpDate = tmpTime.splice(0, 1);
      time = tmpTime[0];


      for (i = 0; i < timeFormat.length; i++) {
        timeFormat[i] = $.trim(timeFormat[i]).substring(0, 1);
      }

      time = ParseTime(tmpTime, timeFormat);
    }

    // Число должно быть не больше, чем в указанном месяце, а месяц - не больше 11 (0 - январь)
    if (daysInMonth >= d && d > 0 && m <= 11 && m >= 0) {
      if (time) {
        return (new Date(y, m, d, time[0], time[1], time[2]));
      }
      else {
        return (new Date(y, m, d));
      }
    }
    else return null;
  }

  return null;
};

/**
* Преобразовать строку в дату с учетом текущей локализации.
*
* @global
* @function parseDate
* @param {String} date Строка даты в формате ДД.ММ.ГГГГ
* @return {string} Отформатированная строка.
*/
function parseDate(date) {
  return window.ParseDateTime(date);
}
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

/**
* Получить хеш указанной строки.
*
* @global
* @function getHash
* @param {string} str Строка, которую необходимо отформатировать
* @return {string} Отформатированная строка.
*
* @example
* console.log(getHash('азбука'));
* console.log(getHash('азбуки'));
* // В результате появятся отформатированные строки:
* //4302529
* //4302537
*/
function getHash(str) {
  if (!str) return 0;
  m = 12345678;
  h = 0;
  for (var i = 0; i < str.length; i++) h = (h * 255 + parseInt(str.charCodeAt(i), 10)) % m;
  return h;
}
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

/**
 * Размеры иконки новой кнопки.
 * @readonly
 * @enum {boolean} BUTTON
 * @since 5.0.0.4104
 * @example
 *
 * //Создать кнопку с иконкой 16x16 пикселей.
 * WebAccess.current.toolBar.groups.ATTACHMENTS.createButton("myButton", BUTTON.SMALL);
 */
var BUTTON = {
  /** Размер иконки кнопки – 32х32 пикселей */
  LARGE: false,
  /** Размер иконки кнопки – 16х16 пикселей */
  SMALL: true
};

/**
* Метод отправки формы на веб-сервер.
*
* @readonly
* @global
* @enum {string} FORM_METHOD
* @since 5.0.0.7100
*/
var FORM_METHOD = {
  /** Отправка методом POST */
  POST: 'POST',
  /** Отправка методом GET */
  GET: 'GET'
};
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

/**
* Тип отправляемых данных формы.
*
* @readonly
* @global
* @enum {string} ENCTYPE
* @since 5.0.0.7100
*/
var ENCTYPE = {
  /** Данные формы в виде бинарного кода */
  MULTIPART: 'multipart/form-data',
  /** Данные формы в текстовом виде */
  URLENCODED: 'application/x-www-form-urlencoded'
};
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//


/**
* Тип справочника с последними и избранными объектами.
*
* @readonly
* @global
* @enum {string} LAST_REFERENCES
* @since 5.0.0.7200
*/
var LAST_REFERENCES = {
  /**  Выбор доступен из справочников «Пользователи», «Группы пользователей» и «Типовые маршруты» */
  ALL: '',
  /** Выбор доступен из справочника «Пользователи» */
  ONLY_USERS: "!SR!G",
  /** Выбор доступен из справочников «Пользователи» и «Группы пользователей» */
  USERS_AND_GROUPS: "!SR"
};
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//


/**
* Тип объекта системы DIRECTUM.
*
* @readonly
* @global
* @enum {integer} OBJECT_TYPE
* @since 5.0.0.7100
*/
var OBJECT_TYPE = {
  /** Неизвестный тип */
  UNKNOWN: 10,
  /** Папка */
  FOLDER: 0,
  /** Документ */
  EDOCUMENT: 1,
  /** Задания */
  JOB: 3,
  /** Задачи */
  TASK: 2,
  /** Компоненты */
  COMPONENT_TOKEN: 4,
  /** Произвольный тип */
  ANY: 5,
  /** Справочники */
  REFERENCE: 6,
  /** Сценарии */
  SCRIPT: 7,
  /** Отчеты */
  REPORT: 8,
  /** Запись справочника */
  REFERENCE_RECORD: 9,
  /** Пользователь */
  USER: 11,
  /** Мастер действий */
  WIZARD: 12,
  /** Пользователь или группа */
  USER_OR_GROUP: 100,
  /** Поиск */
  SEARCH: 101,
  /** Диалог */
  DIALOG: 102
};
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

/**
* Тип состояния делового процесса.
*
* @readonly
* @global
* @enum {string} REQUISITE_TYPE
* @since 5.5.0.9092
*/
var WORK_STATE = {
  /** Инициализация */
  INIT: 0,
  /** В работе */
  RUNNING: 1,
  /** Выполнено */
  DONE: 2,
  /** На контроле */
  CONTROLLED: 3,
  /** Прекращено */
  ABORTED: 4,
  /** Возобновлена */
  CONTINUED: 5
}

/**
* Типы данных значений реквизитов.
*
* @readonly
* @global
* @enum {string} REQUISITE_TYPE
* @since 5.2.0.1300
*/
var REQUISITE_TYPE = {
  /** Пусто */
  EMPTY: 0,
  /** Дата */
  DATE: 1,
  /** Дробное число */
  FLOAT: 2,
  /** Признак */
  PICK: 3,
  /** Строка */
  STRING: 4,
  /** Справочник */
  REFERENCE: 5,
  /** Текст */
  TEXT: 6,
  /** Целое число */
  INTEGER: 7,
  /** Большое целое число */
  LARGE_INTEGER: 8,
  /** Документ */
  DOCUMENT: 9,
  /** Список объектов */
  OBJECT_LIST: 11
}
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

/**
 * @readonly
 * @global
 * @enum {string} ACTION_ENABLED_MODE
 * @since 5.5.0.2201
 */
var ACTION_ENABLED_MODE = {
  /** Доступно. */
  ENABLED_ALWAYS: 0,
  /** Недоступно. */
  DISABLED_ALWAYS: 1,
  /** Доступно при просмотре. */
  ENABLED_ON_BROWSE: 2,
  /** Доступно при редактировании. */
  ENABLED_ON_EDIT: 3,
  /** Недоступно без данных. */
  DISABLED_ON_BROWSE_EMPTY: 4
}

/**
* Преобразовывает типы данных значений реквизита в строковое представление
* @global
* @function requisiteTypeToString
* @param {integer} reqType Целое представление типа
* @return {string} Имя типа данных, например "integer".
* @since 5.2.0.1300
*/
requisiteTypeToString = function (reqType) {
  switch ('' + reqType) {
    case '1':
      return 'date';
    case '2':
      return 'float';
    case '3':
      return 'pick';
    case '4':
      return 'string';
    case '5':
      return 'reference';
    case '6':
      return 'text';
    case '7':
      return 'integer';
    case '8':
      return 'largeinteger';
    case '9':
      return 'document';
    case '11':
      return 'objectList';
  }
}

requisiteTypeFromString = function (reqType) {
  switch (reqType) {
    case 'date':
      return 1;
    case 'float':
      return 2;
    case 'pick':
      return 3;
    case 'string':
      return 4;
    case 'reference':
      return 5;
    case 'text':
      return 6;
    case 'integer':
      return 7;
    case 'largeinteger':
      return 8;
    case 'document':
      return 9;
    case 'objectList':
      return 11;
  }
}

/**
* Преобразовать тип объекта в строку.
*
* @global
* @function objectTypeToString
* @param {OBJECT_TYPE} type Тип объекта
* @return {String} Преобразованная строка. Например, объект типа «Справочник» будет преобразован в строку 'REF'.
* @since 5.0.0.7200
*/
function objectTypeToString(objectType) {
  switch (objectType) {
    case OBJECT_TYPE.EDOCUMENT:
      return "EDOC";
    case OBJECT_TYPE.FOLDER:
      return "FOL";
    case OBJECT_TYPE.TASK:
      return "TASK";
    case OBJECT_TYPE.JOB:
      return "JOB";
    case OBJECT_TYPE.REFERENCE_RECORD:
      return "REF";
    case OBJECT_TYPE.ANY:
      return "ANY";
    case OBJECT_TYPE.UNKNOWN:
      return "UNKNOWN";
    default:
      WA.raise('UNKNOWN_TYPE ' + objectType);
      break;
  }
  return null;
}
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

/**
* Перевод строки в требуемый тип объекта
*
* @global
* @function objectKindToObjectType
* @param {OBJECT_TYPE} type Тип объекта
* @return {OBJECT_TYPE} Объект типа OBJECT_TYPE.
* @since 5.0.0.7200
*/
function objectKindToObjectType(objectKind) {
  if (!objectKind) return null;
  switch (objectKind.toUpperCase()) {
    case "EDOC":
      return OBJECT_TYPE.EDOCUMENT;
    case "FOL":
      return OBJECT_TYPE.FOLDER;
    case "TASK":
      return OBJECT_TYPE.TASK;
    case "JOB":
      return OBJECT_TYPE.JOB;
    case "REF":
      return OBJECT_TYPE.REFERENCE_RECORD;
    case "ANY":
      return OBJECT_TYPE.ANY;
    case "UNKNOWN":
      return OBJECT_TYPE.UNKNOWN;
    default:
      WA.raise('UNKNOWN_TYPE');
      break;
  }
  return null;
}
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

/**
 * Режим расположения.
 *
 * @readonly
 * @enum {integer} ORIENTATION
 * @since 5.0.0.4200
 *
 * @example
 * //Установить горизонтальное расположение боковой панели.
 * WebAccess.current.sideBar.setOrientation(ORIENTATION.HORISONTAL);
 *
 * @example
 * //Установить последовательное горизонтальное расположение элементов на форме.
 * var form = WA.CMP.forms.FormBuilder('someForm');
 * form.setOrientation(ORIENTATION.VERTICAL);
 */
var SIDEBAR_ORIENTATION;
var ORIENTATION = SIDEBAR_ORIENTATION = {
  /** Горизонтальное */
  HORIZONTAL: 0,
  /** Вертикальное */
  VERTICAL: 1
};
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

/**
 * Тип получаемой модели данных.
 *
 * @readonly
 * @enum {integer} MODEL
 * @since 5.0.0.7300
 */
var MODEL = {
  /** Полные данные */
  FULL: 0,
  /** Карточка */
  CARD: 1,
  /** Содержимое объекта */
  CONTENT: 2,
  /** Ссылка */
  LINK: 3
};
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

/**
 * Тип доступа к деловому процессу.
 *
 * @readonly
 * @enum {integer} WORK_ACCESS_TYPE
 * @since 5.0.0.7300
 */
var WORK_ACCESS_TYPE = {
  /** Всем */
  ALL: 0,
  /** Ручной */
  MANUAL: 2,
  /** Участникам */
  PARTICIPANTS: 1
};
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

/**
* Тип задания.
*
* @readonly
* @enum {integer} JOB_KIND
* @since 5.0.0.7300
*/
var JOB_KIND = {
  /** Задание */
  JOB: 0,
  /** Уведомление */
  NOTICE: 1,
  /** Задание-контроль */
  CONTROL_JOB: 2
};
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

/**
* Тип сообщения.
*
* @readonly
* @enum {integer} MESSAGE_TYPE
* @since 5.0.0.7300
*/
var MESSAGE_TYPE = {
  /** Предупреждение */
  WARNING: 0,
  /** Сообщение об ошибке */
  ERROR: 1,
  /** Информационное сообщение */
  INFO: 2
};
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

/**
* Тип содержимого папки.
*
* @readonly
* @enum {integer} FOLDER_CONTENT_TYPE
* @since 5.0.0.7300
*/
var FOLDER_CONTENT_TYPE = {
  /** Документы */
  EDOCUMENT: 1,
  /** Задания */
  JOB: 3,
  /** Задачи */
  TASK: 2,
  /** Вариант запуска */
  COMPONENT_TOKEN: 4,
  /** Произвольный тип */
  ANY: 5
};
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

/**
* Тип папки.
*
* @readonly
* @enum {integer} FOLDER_TYPE
* @since 5.0.0.7300
*/
var SPEC_FOLDER_TYPE = FOLDER_TYPE = {
  /** Папка «Входящие» */
  INBOX: 0,
  /** Папка «Исходящие» */
  OUTBOX: 1,
  /** Папка «Избранное» */
  FAVORITES: 2,
  /** Папка «Общая папка» */
  COMMON_FOLDER: 3,
  /** Папка пользователя */
  USER_FOLDER: 4,
  /** Специальный объект «Ярлыки» */
  SHORTCUTS: 7,
  /** Папка поиска */
  SEARCH: 8
};
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

/**
* Уровень журналирования
*
* @readonly
* @since 5.1.0.1523
* @enum {string} LOG_LEVEL
* @global
*/
var LOG_LEVEL = {
  /** Сообщение об ошибке */
  ERROR: 'E',
  /** Предупреждение */
  WARN: 'W',
  /** Информационное сообщение */
  INFO: 'I',
  /** Сообщение об отладке */
  DEBUG: 'D'
};


/**
* Уровень сериализации
*
* @readonly
* @since 5.2.0.1600
* @enum {integer} SERIALIZATION
* @global
*/
var SERIALIZATION = {
  /** Минимальная сериализация, по умолчанию */
  LITE: '1',
  /** Максимальное кол-во данных */
  FULL: '2'
};


/**
* Названия стандартных действий диалога.
*
* @readonly
* @since 5.2.0.1901
* @enum {String} DIALOG_ACTION
* @global
*/
var DIALOG_ACTION = {
  /** ОК */
  OK: 'OkAction',
  /** Отмена */
  CANCEL: 'CancelAction'
};


/**
* Режим открытия справочника в модальном окне.
*
* @readonly
* @since 5.4.0.1013
* @enum {integer} REFERENCE_MODAL_MODE
* @global
*/
var REFERENCE_MODAL_MODE = {
  /** Просмотр */
  VIEW: 0,
  /** Единичный выбор */
  SINGLE: 1,
  /** Множественный выбор */
  MULTI: 2
};

/**
* Режим открытия справочника в модальном окне.
*
* @readonly
* @since 5.5.0.1000
* @enum {integer} VARIANT_TYPE
* @global
*/
var VARIANT_TYPE = {
  /** Целое число */
  INTEGER: 0,
  /** Число с плавающей точкой */
  SINGLE: 1,
  /** Строка */
  STRING: 2,
  /** Логический тип */
  BOOLEAN: 3,
  /** Дата */
  DATE_TIME: 4,
  /** Задача */
  TASK: 5,
  /** Задание */
  JOB: 6,
  /** Папка */
  FOLDER: 7,
  /** Документ */
  DOCUMENT: 8,
  /** Запись справочника */
  REFERENCE_RECORD: 9,
  /** Пользователь */
  USER: 10,
  /** Группа пользователей */
  USER_GROUP: 11,
  /** Роль */
  USER_ROLE: 12,
  /** Коллекция целых чисел */
  INTEGER_COLLECTION: 13,
  /** Коллекция чисел с плавающей точкой */
  SINGLE_COLLECTION: 14,
  /** Коллекция строк */
  STRING_COLLECTION: 15,
  /** Коллекция логических типов */
  BOOLEAN_COLLECTION: 16,
  /** Коллекция дат */
  DATE_TIME_COLLECTION: 17,
  /** Коллекция задач */
  TASK_COLLECTION: 18,
  /** Коллекция заданий */
  JOB_COLLECTION: 19,
  /** Коллекция папок */
  FOLDER_COLLECTION: 20,
  /** Коллекция документов */
  DOCUMENT_COLLECTION: 21,
  /** Коллекция записей справочника */
  REFERENCE_RECORD_COLLECTION: 22,
  /** Коллекция пользователей */
  USER_COLLECTION: 23,
  /** Коллекция групп пользователей */
  USER_GROUP_COLLECTION: 24,
  /** Коллекция ролей */
  USER_ROLE_COLLECTION: 25
};


/**
* Обрезка длинных строк
* @method String.trunc
* @param {length} допустимая длина
* @since 5.0.0.7300
*/
String.prototype.trunc = function (n) {
  if (!("" + this)) return '';
  if (this.substr) {
    if (n < 4) return this[0] + "...";
    return this.substr(0, n - 3) + (this.length >= n ? '...' : '');
  }
  return "" + this;
};
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

/**
* Обрезка длинных строк
* @method String.trunc
* @param {length} допустимая длина
* @since 5.0.0.7300
*/
String.prototype.switchLayout = function (string) {
  var map = {
    'q': 'й',
    'w': 'ц',
    'e': 'у',
    'r': 'к',
    't': 'е',
    'y': 'н',
    'u': 'г',
    'i': 'ш',
    'o': 'щ',
    'p': 'з',
    '[': 'х',
    ']': 'ъ',
    'a': 'ф',
    's': 'ы',
    'd': 'в',
    'f': 'а',
    'g': 'п',
    'h': 'р',
    'j': 'о',
    'k': 'л',
    'l': 'д',
    ';': 'ж',
    '\'': 'э',
    'z': 'я',
    'x': 'ч',
    'c': 'с',
    'v': 'м',
    'b': 'и',
    'n': 'т',
    'm': 'ь',
    ',': 'б',
    '.': 'ю',
    '\/': '.',
    '\`': 'ё'
  }
  //TODO http://underscorejs.org/#invert для RU-EN
  return _(this).map(function (ch) {
    return map[ch]
  }).join('');
};
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

/**
* Замена всех подстрок в строке
* @method String.replaceAll
* @param {needle} искомая строка
* @param {replacement} замена
* @since 5.0.0.7300
*/
String.prototype.replaceAll = function (needle, replacement) {
  if (this.replace) return this.replace(new RegExp(needle, 'g'), replacement || '');
  else return this;
};
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

/**
* Экранирование HTML
* @method String.escapeHtml
* @since 5.0.0.7300
*/
String.prototype.escapeHtml = function () {
  var entityMap = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': '&quot;',
    "'": '&#39;',
    "/": '&#x2F;'
  };

  return String(this).replace(/[&<>"'\/]/g, function (s) {
    return entityMap[s];
  });

  //$('<div/>').text(this).html().replace(/"/g, "&quot;");
};
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

/**
* Удаление HTML тегов из строки
* @method String.stripHtml
* @since 5.1.0.1505
*/
String.prototype.stripHtml = function () {
  if (this.replace) return this.replace(/<(?:.|\n)*?>/gm, '');
  return this;
};
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//


/**
* Перевод переносов строк в HTML теги br
* @method String.newLinesToBR
* @param {length} допустимая длина
* @since 5.0.0.7300
*/
String.prototype.newLinesToBR = function () {
  if (this.replace) return this.replace(/\\n/g, "<br>");
  else return this;
};
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

/**
* Уадлеяет все символы и пробелы из строки, и возвращает только буквы и числа
* @method String.makeSafeString
* @param {length} Допустимая длина
* @since 5.2.0.1303
*/
String.prototype.makeSafeString = function () {
  if (this.replace) return this.replace(/[^A-ZА-Я0-9]+/ig, "_");
  else return this;
};


/**
* Удаление ведущих и конечных пробелов.
* @method String.trim
* @since 5.0.0.7300
*/
if (typeof String.prototype.trim !== 'function') {
  String.prototype.trim = function () {
    return this.replace(/^\s+|\s+$/g, '');
  };
}

/**
* Метод endsWith() определяет, заканчивается ли строка символами другой строки, возвращая, соотвественно, true или false.
* @method String.endsWith
* @since 5.5.0.9000
*/
if (!String.prototype.endsWith) {
  Object.defineProperty(String.prototype, 'endsWith', {
    value: function (searchString, position) {
      var subjectString = this.toString();
      if (position === undefined || position > subjectString.length) {
        position = subjectString.length;
      }
      position -= searchString.length;
      var lastIndex = subjectString.indexOf(searchString, position);
      return lastIndex !== -1 && lastIndex === position;
    }
  });
}

//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

/**
* Приведение строки билдера к нормальному виду
* @method String.fromISBuilderToNormal
* @since 5.0.0.7300
*/
String.prototype.fromISBuilderToNormal = function () {
  if (!this.replace) return this;
  var str = this;
  var isInBrackets = false;
  var newStr = '';
  for (var i = 0; i < str.length; i++) {
    if (str[i] == '|' && !isInBrackets) {
      newStr = str.substring(0, i) + ' ' + str.substring(i + 1, str.length);
    }
    else if (str[i] === '&' && (i + 5) < str.length) {
      if (str[i + 1] == 'q' && str[i + 2] == 'u' && str[i + 3] == 'o' && str[i + 4] == 't' && str[i + 5] == ';') {
        isInBrackets = !isInBrackets;
        i += 5;
      }
    }
  }
  // ' ывалп \n вава \n новая строка'.replace(/\n/g, ' ')
  if (newStr === '') return str.replace(/\^/g, ' ').replace(/\n/g, '<br/>');
  return newStr.replace(/\^/g, ' ').replace(/\n/g, '<br/>');
};
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

/**
* Создать копию функции.
*
* @function cloneFunction
* @param {Function} func Функция, для которой необходимо создать копию.
* @since 5.0.0.7300
*/
var cloneFunction = function (func) {
  var reFn = /^function\s*([^\s(]*)\s*\(([^)]*)\)[^{]*\{([^}]*)\}$/gi
    , s = func.toString().replace(/^\s|\s$/g, '')
    , m = reFn.exec(s);
  if (!m || !m.length) return null;
  var conf = {
    name: m[1] || '',
    args: m[2].replace(/\s+/g, '').split(','),
    body: m[3] || ''
  };

  var clone = Function.prototype.constructor.apply(this, [].concat(conf.args, conf.body));
  for (var key in func) {
    if (func.hasOwnProperty(key)) {
      clone[key] = func[key];
    }
  }
  return clone;
};
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//


/**
* Получить строку локализации из базы данных системы.
*
* @method getISBString
* @param {String} code Код строки локализации
* @param {boolean} [opt_is_async] Признак ассинхронного получения данных
* @since 5.0.0.7300
*/
function getISBString(msg, opt_is_async) {
  var R = '';
  var data = { 'Code': msg.replace("\'", "\\'") };
  opt_is_async = !!opt_is_async ? opt_is_async : false;
  if (opt_is_async) {
    return WA.SRV.call("/Session.asmx/GetBuilderResources", data);
  } else {
    WA.SRV.callSync("/Session.asmx/GetBuilderResources", data).done(function (res) {
      R = res.d;
    });
    return R;
  }
}

/**
* Генерирует уникальный ID
* @function generateUniqueID
* @global
* @param {Integer} len длина возвращаемой строки
* @since 5.2.0.1100
*/
function generateUniqueID(len, radix) {
  var CHARS = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('');
  var chars = CHARS, uuid = [], i;
  radix = radix || chars.length;

  if (len) {
    // Compact form
    for (i = 0; i < len; i++) uuid[i] = chars[0 | Math.random() * radix];
  } else {
    // rfc4122, version 4 form
    var r;

    // rfc4122 requires these characters
    uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-';
    uuid[14] = '4';

    // Fill in random data.  At i==19 set the high bits of clock sequence as
    // per rfc4122, sec. 4.1.5
    for (i = 0; i < 36; i++) {
      if (!uuid[i]) {
        r = 0 | Math.random() * 16;
        uuid[i] = chars[(i == 19) ? (r & 0x3) | 0x8 : r];
      }
    }
  }

  return uuid.join('');
}

/**
* Преобразовывает строку с датой формата ISO в объект типа Date.
* @method Date.fromISO
* @param {String} s дата в формате ISO
* @since 5.2.0.1100
*/
(function () {
  var D = new Date('2011-06-02T09:34:29+02:00');
  if (!D || +D !== 1307000069000) {
    Date.fromISO = function (s) {
      var day, tz,
      rx = /^(\d{4}\-\d\d\-\d\d([tT ][\d:\.]*)?)([zZ]|([+\-])(\d\d):(\d\d))?$/,
      p = rx.exec(s) || [];
      if (p[1]) {
        day = p[1].split(/\D/);
        for (var i = 0, L = day.length; i < L; i++) {
          day[i] = parseInt(day[i], 10) || 0;
        };
        day[1] -= 1;
        day = new Date(Date.UTC.apply(Date, day));
        if (!day.getDate()) return NaN;
        if (p[5]) {
          tz = (parseInt(p[5], 10) * 60);
          if (p[6]) tz += parseInt(p[6], 10);
          if (p[4] == '+') tz *= -1;
          if (tz) day.setUTCMinutes(day.getUTCMinutes() + tz);
        }
        return day;
      }
      return NaN;
    }
  }
  else {
    Date.fromISO = function (s) {
      return new Date(s);
    }
  }
})();

/**
* Возможность перезаписи функций, с возможностью запуска родительской функции.
* @inner
*/
Function.prototype.override = function (func) {
  var superFunction = this;
  return function () {
    this.superFunction = superFunction;
    return func.apply(this, arguments);
  };
};

/**
* Скрывает все выпадаюшие менюшки (выбор из справочника, pick, множественный выбор фильтра по колонкам).
* @inner
*/
function hideAllPopups() {
  // Скрываем выборы из справочника.
  $('.rs_container').hide();
  // Скрываем множественный выбор для колонки грида.
  $('.selectListPopup').hide();
}

//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

/**
 * Режим открытия документа в мастере действий.
 *
 * @readonly
 * @enum {integer} WIZARD_DOCUMENT_STEP_SHOW_MODE
 * @since 5.4.1.1000
 */
var WIZARD_DOCUMENT_STEP_SHOW_MODE = {
  /** Открывать содержимое документа  */
  BODY: 0,
  /** Открывать карточку документа */
  CARD: 1
};

//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

/**
 * Операции доступные для токена.
 *
 * @readonly
 * @enum {integer} TOKEN_OPERATION
 * @since 5.4.2.2000
 */
var TOKEN_OPERATION = {
  /** Токен для операции получения тела документа  */
  DOWNLOAD_DOCUMENT_BODY: 1,
  /** Открывать карточку документа */
  UPLOAD_DOCUMENT_BODY: 2,
  /** Токен для операции обновления агента */
  UPDATE_AGENT: 4,
  /** Токен для операции подписания документа */
  SIGN_DOCUMENT: 8,
  /** Токен для операции подписания задачи или задания */
  SIGN_TASK: 8,
  /** Токен для операции получения списка новых заданий */
  GET_NEW_JOB_LIST: 16,
  /** Токен для операции блокирования тела документа */
  LOCK_VERSION: 32,
  /** Токен для операции снятия блокировки с тела документа */
  UNLOCK_VERSION: 64,
  /** Токен для операции получения зашифрованного сессионного ключа */
  GET_ENCRYPTION_KEY: 128,
  /** Токен для операции диагностики */
  DIAGNOSTICS: 1073741824
};

//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

// Исправляет косяк IE - после манипуляций с DOM, в которых есть svg>use, картинки не отображаются.
function fixSvg(el) {
  if (WA.ENV.browser.name !== 'IE') return;

  var xmlns = "http://www.w3.org/2000/svg";
  var xlink = 'http://www.w3.org/1999/xlink';

  var replacingSvgs = [];
  var svgs = el.getElementsByTagName('svg'); // результаты "живые", поэтому в этой функции неменяется DOM (не делается insertBefore и removeChild)
  for (var i = 0; i < svgs.length; i++) {
    var prevSvg = svgs[i];
    var svgUse = prevSvg.firstChild;
    var svgName = svgUse.getAttribute('xlink:href') || svgUse.getAttribute('href');

    var newSvg = document.createElementNS(xmlns, "svg");
    newSvg.setAttribute('class', prevSvg.className.baseVal);
    var newSvgUse = document.createElementNS(xmlns, 'use');
    newSvgUse.setAttributeNS(xlink, 'href', svgName);
    newSvg.appendChild(newSvgUse);

    replacingSvgs.push({ prevSvg: prevSvg, newSvg: newSvg });
  }
  replacingSvgs.forEach(function (r) {
    var parent = r.prevSvg.parentNode;
    parent.insertBefore(r.newSvg, r.prevSvg);
    parent.removeChild(r.prevSvg);
  });
}